module.exports = __webpack_public_path__ + "img/egg_plant_sad.6b99ef30.svg";